import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import TalukDataTable from "./TalukDataTables"
import MetaTag from "components/Common/Meta-tag"

function Taluks() {
  return (
    <>
      <MetaTag title={"All Taluks"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All Taluks" />
        <Container fluid>
          <div className="container-fluid">
            <TalukDataTable />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Taluks
